import React from 'react';
import { Navigate } from 'react-router-dom';
import { useUser } from '../context/UserContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useUser();

  // If still loading, show a loading indicator
  if (loading) {
    return <div>Loading...</div>; // You can replace this with a spinner
  }

  // If no user, redirect to login
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // If user exists, render the children components
  return children;
};

export default ProtectedRoute;